module.exports = __webpack_public_path__ + "static/media/garland.bfcd2ee7.webp";